export function resolveLocale(locale) {
  if (!locale) {
    return void 0;
  }
  const tags = locale.split(",").map(tag => tag.trim()).filter(Boolean);
  return tags.length > 1 ? tags : tags[0];
}